/* tslint:disable */
/* eslint-disable */
/**
 * Swagger wiegaaterkoffiehalen
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.3.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type MyProfileObject,
    MyProfileObjectFromJSON,
    MyProfileObjectToJSON,
} from '../models/MyProfileObject';
import {
    type SsoToken,
    SsoTokenFromJSON,
    SsoTokenToJSON,
} from '../models/SsoToken';
import {
    type UserBody,
    UserBodyFromJSON,
    UserBodyToJSON,
} from '../models/UserBody';

export interface GetProfileRequest {
    /**
     * 
     */
    accessToken: string;
}

export interface GetSsoRequest {
    /**
     * 
     */
    accessToken: string;
}

export interface UpdateUserRequest {
    /**
     * 
     */
    accessToken: string;
    /**
     * 
     */
    userBody: UserBody;
}

/**
 * 
 */
export class UsersApi extends runtime.BaseAPI {

    /**
     * Creates request options for getProfile without sending the request
     */
    async getProfileRequestOpts(requestParameters: GetProfileRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['accessToken'] == null) {
            throw new runtime.RequiredError(
                'accessToken',
                'Required parameter "accessToken" was null or undefined when calling getProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accessToken'] != null) {
            headerParameters['access-token'] = String(requestParameters['accessToken']);
        }


        let urlPath = `/users`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get own profile
     */
    async getProfileRaw(requestParameters: GetProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MyProfileObject>> {
        const requestOptions = await this.getProfileRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MyProfileObjectFromJSON(jsonValue));
    }

    /**
     * Get own profile
     */
    async getProfile(requestParameters: GetProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MyProfileObject> {
        const response = await this.getProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSso without sending the request
     */
    async getSsoRequestOpts(requestParameters: GetSsoRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['accessToken'] == null) {
            throw new runtime.RequiredError(
                'accessToken',
                'Required parameter "accessToken" was null or undefined when calling getSso().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accessToken'] != null) {
            headerParameters['access-token'] = String(requestParameters['accessToken']);
        }


        let urlPath = `/users/ssotoken`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get SSO token
     */
    async getSsoRaw(requestParameters: GetSsoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SsoToken>> {
        const requestOptions = await this.getSsoRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SsoTokenFromJSON(jsonValue));
    }

    /**
     * Get SSO token
     */
    async getSso(requestParameters: GetSsoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SsoToken> {
        const response = await this.getSsoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateUser without sending the request
     */
    async updateUserRequestOpts(requestParameters: UpdateUserRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['accessToken'] == null) {
            throw new runtime.RequiredError(
                'accessToken',
                'Required parameter "accessToken" was null or undefined when calling updateUser().'
            );
        }

        if (requestParameters['userBody'] == null) {
            throw new runtime.RequiredError(
                'userBody',
                'Required parameter "userBody" was null or undefined when calling updateUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['accessToken'] != null) {
            headerParameters['access-token'] = String(requestParameters['accessToken']);
        }


        let urlPath = `/users`;

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UserBodyToJSON(requestParameters['userBody']),
        };
    }

    /**
     * Update user
     */
    async updateUserRaw(requestParameters: UpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update user
     */
    async updateUser(requestParameters: UpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUserRaw(requestParameters, initOverrides);
    }

}
